import axios from "axios";

// axios.defaults.baseURL = "http://localhost:8000/api";
// axios.defaults.baseURL = "http://192.168.1.72:8000/api";
axios.defaults.baseURL = "https://najih-backend.developnetwork.net/api";


export default axios;


